var notified = new Array();

//do not make checkboxes for these static event types
var filterTable = [
  /* Groups */
  "Pile Spawn", // Old Event
  "Glitch", // Old Event
  "Puppet", // Encore Dungeon
  "Monument", // Shatters Dungeon
  "Pumpkin of", // Puppet Dungeon
  "Beehemoth", // Sub Events
  "Merc A", // Mercenary Duplicate
  "Merc B", // Mercenary Duplicate
  "Merc C", // Mercenary Duplicate
  "Merc D", // Mercenary Duplicate
  "Vindication Announcer", // Mercenary Duplicate
  "Void Herald", // Unknown Purpose

  /* Singles */
  "Alien Leprechaun", // Old Event
  "Alien Realm Leprechaun Spawner", // Old Event
  "Alien Realm Leprechaun Initiator", // Old Event
  "Archbishop Leucoryx", // O3
  "Chancellor Dammah", // O3
  "Chief Beisa", // O3
  "Cursed Blast", // Unknown
  "Deep Sea Beast", // Old Event
  "Dragon Spawner", // Unknown
  "Dragon Initiator", // Unknown
  "Event Chest", // Irrelevant
  "Easter Egg Basket", // Old Event
  "Hard Merc 2", // Unknown
  "Hero Helper Counter", // Unknown
  "Heroic Septavius", // Dungeon
  "Huntress Pumpkin", // Dungeon
  "Ivory Wyvern", // Dungeon
  "Leprechaun Statue", // Old Event
  "Limoz", // Dungeon
  "Mirror Wyvern", // Dungeon
  "Monolith Siphon", // Sub-event
  "Nikao", // Dungeon
  "Oryxmas Gift", // Irrelevant
  "Presents", // Irrelevant
  "Pumpkin Blast", // Dungeon
  "Purple Leprechaun", // Unknown
  "Pyyr", // Dungeon
  "RSM Snowman", // Unknown
  "Sarcophagus", // Dungeon
  "Snow Construct", // Old Event
  "Snowy Spawner Object", // Unknown
  "St Patricks Event Anchor", // Irrelevant
  "Stone Guardian", // Old Event
  "The Pumpkin Master", // Dungeon
  "Thessal the Mermaid Goddess", // Dungeon
  "Trickster Pumpkin", // Dungeon
  "Wandering Turkey", // Old Event
  "Wizard Puppet", // Dungeon
  "Yellow Leprechaun", // Old Event
];

//name replace from static event types list
var replaceTable = {
  "Beer Encounter": "Beer God",
  "EH Event Hive Summoner": "Killer Bee Nest",
  "Lord of the Lol 0": "Lord of the Lost Lands",
  "Oryx Statue": "Oryx Horde",
  "Pentaract Tower Ultra": "Pentaract",
  "Pumpkin Shrine": "Skull Shrine",
  "Realm Leprechaun": "Leprechaun",
  "Train Encounter": "Kogbold Expedition Engine",

  "Dragon Head": "Rock Dragon",
  "Eye of the Dragon": "Rock Dragon",

  "Alien Biff": "Biff",
  "Biff the Buffed Bunny": "Biff",
  "Mysterious Egg": "Biff",

  "Amethyst Revealer": "The Keyper",
  "Emerald Revealer": "The Keyper",
  "Ruby Revealer": "The Keyper",
  "Sapphire Revealer": "The Keyper",
  "Topaz Revealer": "The Keyper",

  Amethyst: "The Keyper",
  Emerald: "The Keyper",
  Ruby: "The Keyper",
  Sapphire: "The Keyper",
  Topaz: "The Keyper",

  "Black Blade Ozuchi": "Mercenary",
  "Izel the Grand Shaman": "Mercenary",
  "Nefret the Pharaoh": "Mercenary",
  "Pirate Queen Ramm": "Mercenary",

  Statues: "Temple Statue",
  "Jade Statue": "Temple Statue",
  "Garnet Statue": "Temple Statue",
  //"Temple Encounter": "Temple Statue",

  "Daeva Heralds": "Daeva Prison",
  "Void Heralds": "Void Herald",
  /*
  "Void Herald Spawner Haunted Hallows": "Void Herald",
  "Void Herald Spawner Ancient City": "Void Herald",
  "Void Herald Spawner Risen Hells": "Void Herald",
  "Void Herald Spawner Coral Reefs": "Void Herald",
  "Void Herald Spawner Shipwreck": "Void Herald",
  "Void Herald Spawner Dead Church": "Void Herald",
  "Void Herald Spawner Sprite Forest": "Void Herald",
  */
  "Blooming Flowers Realm": "Blooming Flowers",
  "Realm Initiator": "",
  "Realm Spawner": "",
  "Haunted Hallows": "",
  "Abandoned City": "",
  "Abandoned": "",
  "Ancient City": "",
  "Risen Hells": "",
  "Risen Hell": "",
  "Coral Reefs": "",
  "Shipwreck": "",
  "Ship Wreck": "",
  "Dead Church": "",
  "Sprite Forest": "",

  "LNY Altar": "White Snake",
  "LNY Realm Altar": "White Snake",

  "New Zombie Horde Spawner 3": "Zombie Horde",
  "Totalia Spawner 3": "Totalia",

  "AI Alien Taunt": "Alien UFO",
  "RSM Snowman Body Generator": "Snowy The Frost God",
  
  "mgm2 Dungeon": "The Trials of Cronus",
  "mgm2 Portal": "The Trials of Cronus",
  
  "New Turkey God Spawner 3": "Turkey God",

  Anchor: "",
  Spawner: "",
  Initiator: "",
  Announcer: "",
  New: "",
  1: "",
  2: "",
  "\\?": "",
  The: "",
};

//hide these events from the list
var ignoreTable = [
  "16970", // Monolith Siphon
  "16936", // Monolith Siphon
  "16937", // Monolith Siphon
  "16938", // Monolith Siphon

  "4324", // Beehemoth
  "4325", // Beehemoth
  "4326", // Beehemoth
  "2220", // Beehemoth

  "44146", //Void Heralds Initiator
  "44147", //Void Heralds Spawner
  "2463", //Void Heralds Spawner Coral Reefs
  "2464", //Void Heralds Spawner Dead Church
  "2465", //Void Heralds Spawner Ancient City
  "2466", //Void Heralds Spawner Risen Hells
  "2467", //Void Heralds Spawner Sprite Forest
  "2468", //Void Heralds Spawner Haunted Hallows
  "2469", //Void Heralds Spawner Shipwreck

  "20799", // Flying Behemoth
  "51836", // Mercenary A Announcer 1
  "51837", // Mercenary A Announcer 2
  "51838", // Mercenary B Announcer 1
  "51839", // Mercenary B Announcer 2
  "51886", // Mercenary C Announcer 1
  "51887", // Mercenary C Announcer 2
  "51888", // Mercenary C Announcer 3
  "51889", // Mercenary D Announcer 1
  "51890", // Mercenary D Announcer 2
  "51891", // Mercenary D Announcer 3
  "31095", // Mercenary Duplicate
  "31096", // Mercenary Duplicate
  "31097", // Mercenary Duplicate
  "31098", // Mercenary Duplicate

  "46074", // Duplicate Snow Frost God

  "22148", // New Temple Encounter
  "28615", // Temple Encounter

  "22238", // St. Patricks Spawner
  "22239", // St. Patricks Spawner
  "22240" // St. Patricks Spawner
];

var nameTable = {
  0: "⚠️ Event Notifier is under maintenance!",
  1: "Staff Member",
  2: "Realm Found",
  3: "Realm Closed",
  4: "Oryx 3 Realm",
  13100: "The Trials of Cronus",
};

var imageTable = {
  "⚠️ Event Notifier is under maintenance!": "https://i.imgur.com/KmYl3hO.gif",
  "Staff Member": "https://realm.wiki/Sprite/ByItemId?id=2323",
  "Realm Closed": "https://realm.wiki/Sprite/ByObjectId?id=1810",
  "Realm Found": "https://realm.wiki/Sprite/ByObjectId?id=1810",
  "Oryx 3 Realm": "https://realm.wiki/Sprite/ByObjectId?id=45363",
  "Beer God": "https://realm.wiki/Sprite/ByObjectId?id=22128",
  Keyper: "https://realm.wiki/Sprite/ByObjectId?id=19246",
  Unknown: "https://i.imgur.com/b59f6ff.png",
  Totalia: "https://realm.wiki/Sprite/ByObjectId?id=15567",
  "Santappetizer": "https://realm.wiki/Sprite/ByObjectId?id=32954",
  "Jester Box": "https://realm.wiki/Sprite/ByObjectId?id=52286",
  "Daeva Prison": "https://realm.wiki/Sprite/ByObjectId?id=44143",
};

function copyToClipboard(text) {
  var dummy = document.createElement("textarea");
  document.body.appendChild(dummy);
  dummy.value = text;
  dummy.select();
  document.execCommand("copy");
  document.body.removeChild(dummy);
}

function minLuminance(hex, minLuminance = 0.5) {
  function hexToRGB(hex) {
    let r = parseInt(hex.slice(0, 2), 16);
    let g = parseInt(hex.slice(2, 4), 16);
    let b = parseInt(hex.slice(4, 6), 16);
    return [r, g, b];
  }

  function calculateLuminance([r, g, b]) {
    const a = [r, g, b].map(function (v) {
      v /= 255;
      return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
    });
    return a[0] * 0.2126 + a[1] * 0.7152 + a[2] * 0.0722;
  }

  let rgb = hexToRGB(hex);
  let alpha = hex.length === 8 ? hex.slice(6, 8) : "";
  let luminance = calculateLuminance(rgb);

  if (luminance < minLuminance) {
    let scale = Math.sqrt(minLuminance / luminance);
    rgb = rgb.map((v) => Math.min(255, Math.round(v * scale)));
  }

  let newHex = rgb.map((v) => v.toString(16).padStart(2, "0")).join("") + alpha;
  return newHex;
}

function save() {
  var arrData = [];
  var inputs = document.querySelectorAll('input[type="checkbox"]');
  inputs.forEach(function (input) {
    arrData.push({ id: input.id, type: "checkbox", checked: input.checked });
  });

  var dropdowns = document.querySelectorAll("select");
  dropdowns.forEach(function (dropdown) {
    arrData.push({ id: dropdown.id, type: "dropdown", value: dropdown.value });
  });

  localStorage.setItem("inputs", JSON.stringify(arrData));
}

function load() {
  callWiki("DungeonTypes")
    .catch((error) => {
      filters.innerText = "Please report this error: " + error;
    })
    .then((result) => {
      for (var type of result.split(/[\r\n]+/)) {
        if (!type.includes("|")) {
          continue;
        }

        var data = type.split("|");
        var id = data[0];
        var name = data[1];

        nameTable[id] = name;
      }

      load_2();
    });
}

function load_2() {
  var filters = document.getElementById("filters");

  callWiki("EventTypes")
    .catch((error) => {
      filters.innerText = "Please report this error: " + error;
    })
    .then((result) => {
      var types = {};

      for (var type of result.split(/[\r\n]+/)) {
        if (!type.includes("|")) {
          continue;
        }

        var data = type.split("|");
        var id = data[0];
        var color = data[1];
        var name = data[2];

        if (filterTable.some((filterItem) => name.includes(filterItem))) {
          continue;
        }

        Object.keys(replaceTable).forEach((key) => {
          name = name.replace(new RegExp(key, "g"), replaceTable[key]);
        });

        name = name.trim();

        if (color == "000000FF") {
          color = "DCDCDCFF";
        } else {
          color = minLuminance(color);
        }

        nameTable[id] = name;
        types[name] = {
          id: id,
          color: color,
        };
      }

      var output = [];

      for (let name of Object.keys(types).sort()) {
        var data = types[name];

        output.push(`
          <li>
            <label style="color: #${data.color}">
              <input type="checkbox" id="${name}" checked="checked" onchange="updateHistory(false)" />
              ${name}
            </label>
          </li>
        `);
      }

      filters.innerHTML = output.join("");

      var settings = JSON.parse(localStorage.getItem("inputs"));

      if (settings != null) {
        settings.forEach(function (setting) {
          var input = document.getElementById(setting.id);
          if (input) {
            if (setting.type === "checkbox") {
              input.checked = setting.checked;
            } else if (setting.type === "dropdown") {
              input.value = setting.value;
            }
          }
        });
      }

      updateHistory(true);
      updateRealms(true);
    });
}

function filterOk(id) {
  if (id == 4) {
    return true;
  }

  var filter = document.getElementById(id);

  if (filter != null) {
    return filter.checked;
  }

  return true;
}

function copyIp(guid) {
  var email = window.localStorage.getItem("member-email");

  if (!email) {
    whitelist();
    return;
  }

  callApi("EventIp?email=" + email + "&id=" + guid)
    .catch((error) => {
      if (error.message == 423) {
        alert("Please slow down!");
      } else {
        window.localStorage.removeItem("member-email");
        console.log(error);
        alert("❌ Please contact support! Error: " + error.message);
      }
    })
    .then((result) => {
      if (result.success) {
        var multitoolJoin = document.getElementById("multitool-join").checked;
        if (multitoolJoin) {
          document.getElementById(guid).innerText = "Joined " + result.value;
          window.open("multitool://" + result.value, "_blank");
        } else {
          document.getElementById(guid).innerText = "Copied " + result.value;
          copyToClipboard(result.value);
        }
      } else {
        window.localStorage.removeItem("member-email");
        alert(result.value);
      }
    });
}

function copyIpRaw(ip, sender) {
  var multitoolJoin = document.getElementById("multitool-join").checked;
  if (multitoolJoin) {
    sender.innerText = "Joined " + ip;
    window.open("multitool://" + ip, "_blank");
  } else {
    copyToClipboard(ip);
    sender.innerText = "Copied " + ip;
  }
}

function whitelist(realms) {
  var email = prompt(
    "💭 IP access is for Customers who have $4.99 worth of purchases total in the past 30 days.\n\n" +
      "Enter your RealmStock Purchase Email below to unlock access:"
  );

  if (!email) return;

  var order = prompt(
    "💭 Enter your most recent RealmStock Order Number below to unlock access:\n\n" +
      "Example: 123456"
  );

  if (!order) return;

  order = order.replace("#", "").replace("S", "").replace("-", "").trim();
  email = email.trim();

  window.localStorage.removeItem("member-email");
  callApi("RequestAccess?email=" + email + "&order=" + order)
    .catch((error) => {
      if (error.message == 423) {
        alert("⚠️ Please slow down!");
      } else {
        window.localStorage.removeItem("member-email");
        console.log(error);
        alert("❌ Please contact support! Error: " + error.message);
      }
    })
    .then((result) => {
      if (result.success) {
        window.localStorage.setItem("member-email", email);
        if (realms) {
          updateRealms(true);
        }
      }

      alert(result.value);
    });
}

function serverOk(server, sourceId) {
  if (!server) {
    return true;
  }

  var source = document.getElementById(sourceId).value;

  switch (source) {
    case "USServers":
      return server.startsWith("US");
    case "EUServers":
      return server.startsWith("EU");
    case "ASServers":
      return server.startsWith("Asia");
    case "AUServers":
      return server.startsWith("Australia");
    case "AllServers":
      return true;
    default:
      return server === source;
  }
}

var initial = true;
function updateHistory(loop) {
  console.log("updating...");
  save();

  callApi("EventHistory")
    .catch((error) => {
      document.getElementById("history").innerText =
        "Failed to load event history! Please refresh the page.";
    })
    .then((result) => {
      var history = document.getElementById("history");
      var entries = result.value.split("\n");
      var results = [];
      var added = false;
      var alreadyNotified = false;

      for (var entry of entries) {
        if (!entry.includes("|")) {
          continue;
        }

        var splits = entry.split("|");
        var id = splits[0];
        //if (ignoreTable.includes(id)) {
        //  continue;
        //}

        var title = id in nameTable ? nameTable[id] : parseInt(id);
        var image =
          title in imageTable
            ? imageTable[title]
            : "https://realm.wiki/Sprite/ByObjectId?id=" + id;
        var realm = splits[1];
        var nexus = realm == "Nexus";
        var server = splits[2];
        var population = splits[3];
        var populationMax = nexus ? 200 : 85;
        var populationQueue =
          parseInt(population) >= populationMax ? "event-population-queue" : "";
        var events = splits[4] == "-1" ? "?" : splits[4];
        var score = splits[5];
        var time = splits[6];
        var guid = splits[7];
        var special = splits[8];
        var enemyscore = splits[9];
        var specialColor = special.toLowerCase() == "true" ? "aqua" : "gold";

        if (!nexus && !document.getElementById(title) && id != 4) {
          console.log("Unknown Event Type: " + id + " - " + nameTable[id]);
        }

        if (!filterOk(title) || !serverOk(server, "server-filter")) {
          continue;
        }

        if (!server) {
          continue;
        }

        if (nexus && !filterOk("Nexus Dungeon Key")) {
          continue;
        }

        added = true;

        var scoreDisplay = nexus
          ? ""
          : score == "?"
          ? events == "?"
            ? ""
            : `Left: ${events}`
          : `Score: ${score}%`;

        results.push({
          element: `
            <div class="realmstock-panel event">
  <img class="event-icon" loading="lazy" src="${image}" />
  <div class="event-content">
    <h2 class="event-title">${title}</h2>
    <table class="event-table">
      <tr>
        <td class="event-server">
          ${server}
          <span class="event-realm">${realm}</span>
          <span class="event-population ${populationQueue}">${population}/${populationMax}</span>
        </td>
        <td class="event-score">${scoreDisplay}</td>
        <td class="event-time">${convertUTCToLocal(time)}</td>
        <td class="event-ip" id="${guid}"><a style="color:${specialColor} !important"onclick="copyIp('${guid}')">➜ Direct Connect</a></td>
      </tr>
    </table>
  </div>
</div>
          `,
          population: population,
          score: score === "?" ? -1 : parseFloat(score),
          time: new Date(time),
          events: events === "?" || score !== "?" ? 0 : parseInt(events),
          enemyscore: enemyscore,
        });

        if (!notified.includes(guid)) {
          notified.push(guid);

          if (
            initial ||
            alreadyNotified ||
            !document.getElementById("desktop-notifications")?.checked
          ) {
            // do nothing
          } else if (!("Notification" in window)) {
            alert("This browser does not support desktop notifications!");
          } else if (Notification.permission === "granted") {
            notify(
              server,
              realm,
              population,
              populationMax,
              title,
              image,
              guid
            );
          } else if (Notification.permission !== "denied") {
            Notification.requestPermission().then(function (permission) {
              if (permission === "granted") {
                notify(
                  server,
                  realm,
                  population,
                  populationMax,
                  title,
                  image,
                  guid
                );
              }
            });
          } else {
            console.log(Notification.permission);
          }

          alreadyNotified = true;
        }
      }

      var sortCriteria = document.getElementById("sorting-select").value;
      if (sortCriteria === "population") {
        results.sort((a, b) => b.population - a.population);
      } else if (sortCriteria === "score") {
        results.sort((a, b) => b.score - a.score);
      } else if (sortCriteria === "time") {
        results.sort((a, b) => b.time - a.time);
      } else if (sortCriteria === "left") {
        results.sort((a, b) => b.events - a.events);
      } else if (sortCriteria === "enemyscore") {
        results.sort((a, b) => b.enemyscore - a.enemyscore);
      }

      var resultElements = results.map((result) => result.element);
      resultElements.push(
        `<div><span>${results.length} results! Refreshing in 5 seconds.</span><br/></div>`
      );
      history.innerHTML = resultElements.join("");
      initial = false;

      if (loop) {
        setTimeout(() => {
          updateHistory(true);
        }, 5000);
      }
    });
}

function updateRealms(loop) {
  console.log("updating realms...");

  var email = window.localStorage.getItem("member-email");
  if (!email) {
    document.getElementById("realms").innerHTML =
      "<span style='color:aqua'>For users with Exclusive Access only.</span>" +
      "<br><br><button class='btn tab active btn-solid color-background-1' onclick='whitelist(true)'>Log In</button>";
    return;
  }

  callApi("RealmHistory?email=" + email)
    .catch((error) => {
      document.getElementById("realms").innerText =
        "Failed to load realm list! Please refresh the page.";
    })
    .then((result) => {
      if (!result.success) {
        document.getElementById("realms").innerHTML =
          `<span>Failed to load realm list: ${result.value}</span>` +
          "<br><button class='btn tab active btn-solid color-background-1' onclick='whitelist(true)'>Log In</button>";
        return;
      }

      var realmsContainer = document.getElementById("realms");
      var entries = result.value.split("\n");
      var results = [];

      for (var entry of entries) {
        if (!entry.includes("|")) {
          continue;
        }

        var splits = entry.split("|");
        var name = splits[0];
        var address = splits[1];
        var realm = splits[2];
        var population = splits[3];
        var populationQueue =
          parseInt(population) >= 85 ? "event-population-queue" : "";
        var events = splits[4] == "-1" ? "?" : splits[4];
        var score = splits[5];

        var scoreDisplay =
          score == "?"
            ? events == "?"
              ? "Unknown"
              : `Left: ${events}`
            : `Score: ${score}%`;

        if (!serverOk(name, "server-filter-realms")) {
          continue;
        }

        results.push({
          element: `
            <tr>
              <td class="event-server">${name}</td>
              <td class="event-realm">${realm}</td>
              <td class="event-population ${populationQueue}">${population}/85</td>
              <td class="event-score">${scoreDisplay}</td>
              <td class="event-ip"><a style="color:aqua !important" onclick="copyIpRaw('${address}', this)">➜ Connect</a></td>
            </tr>
          `,
          population: population,
          score: score === "?" ? -1 : parseFloat(score),
          events: events === "?" || score !== "?" ? 0 : parseInt(events),
        });
      }

      var sortCriteria = document.getElementById("sorting-select-realms").value;
      if (sortCriteria === "population") {
        results.sort((a, b) => b.population - a.population);
      } else if (sortCriteria === "score") {
        results.sort((a, b) => b.score - a.score);
      } else if (sortCriteria === "left") {
        results.sort((a, b) => b.events - a.events);
      }

      var tableHTML = `
        <table border="1" style="width:100%">
          <thead>
            <tr>
              <th>Server</th>
              <th>Realm</th>
              <th>Population</th>
              <th>Status</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            ${results.map((result) => result.element).join("")}
          </tbody>
        </table>
      `;

      realmsContainer.innerHTML =
        tableHTML +
        `<br><div><span>${results.length} results! Refreshing in 5 seconds.</span><br/></div>`;

      if (loop) {
        setTimeout(() => {
          updateRealms(true);
        }, 5000);
      }
    });
}

function convertUTCToLocal(timeString) {
  const [hours, minutes] = timeString.split(":").map(Number);
  const date = new Date();
  date.setUTCHours(hours, minutes, 0, 0);
  return date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
}

function notify(server, realm, population, populationMax, title, image, guid) {
  var notification = new Notification(title, {
    body: `${server} ${realm} ${population}/${populationMax}`,
    icon: image,
  });
  notification.onclick = function () {
    copyIp(guid);
  };
}

async function callApi(endpoint) {
  let baseUrl = "https://realmstock.network/Notifier/";
  let response = await fetch(baseUrl + endpoint);

  if (!response.ok) {
    throw new Error(response.status);
  }

  let data = await response.json();
  return data;
}

async function callWiki(endpoint) {
  let baseUrl = "https://realm.wiki/RealmStock/";
  let response = await fetch(baseUrl + endpoint);

  if (!response.ok) {
    throw new Error(response.status);
  }

  let data = await response.text();
  return data;
}
